import styles from './Approval.module.css';
import modal from './images/modal.svg';
import {
    OptimizedMotionH1,
    OptimizedMotion,
    OptimizedMotionH2,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
import ReadMoreButton from './ReadMoreButton';
import { useNavigate } from 'react-router-dom';

const Approval = () => {
    const navigate = useNavigate();
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                {/* Left Side - Modal Image */}
                <div className={styles.leftSide}>
                    <img src={modal} alt="Approval modal" className={styles.modalImage} />
                </div>

                {/* Right Side - Title and Features */}
                <div className={styles.rightSide}>
                    {/* Title */}
                    <OptimizedMotionH2 className={styles.title} type="slide-left" delay={0.2}>
                        <span className={styles.titleHighlight}>Approval</span>{' '}
                        <span className={styles.wrenchIcon}>✅</span> process
                    </OptimizedMotionH2>

                    {/* Feature 1 */}
                    <div className={styles.featureItem}>
                        <div className={styles.featureNumber}>1</div>
                        <OptimizedMotion
                            className={styles.featureContent}
                            type="slide-down"
                            delay={0.1}
                        >
                            <h3 className={styles.featureTitle}>Clear roles, zero confusion</h3>
                            <p className={styles.featureDescription}>
                                Set sequential or parallel approval paths that mirror your org
                                chart: Creator ➜ Director ➜ Legal ➜ Exec. Each reviewer sees only
                                the steps that belong to them, with built‑in SLAs and reminder
                                nudges.
                            </p>
                        </OptimizedMotion>
                    </div>

                    {/* Feature 2 */}
                    <div className={styles.featureItem}>
                        <div className={styles.featureNumber}>2</div>
                        <OptimizedMotion
                            className={styles.featureContent}
                            type="slide-down"
                            delay={0.3}
                        >
                            <h3 className={styles.featureTitle}>One‑click sign‑off</h3>
                            <p className={styles.featureDescription}>
                                Approvers annotate, accept, or request changes without downloading a
                                file or hunting for an email. Digital signatures and hand‑off
                                timestamps lock when all checks pass, triggering automatic
                                publishing or the next workflow stage.
                            </p>
                        </OptimizedMotion>
                    </div>

                    {/* Feature 3 */}
                    <div className={styles.featureItem}>
                        <div className={styles.featureNumber}>3</div>
                        <OptimizedMotion
                            className={styles.featureContent}
                            type="slide-down"
                            delay={0.5}
                        >
                            <h3 className={styles.featureTitle}>Audit‑ready compliance</h3>
                            <p className={styles.featureDescription}>
                                Every comment, change, and sign‑off is logged for regulators and
                                stakeholders. Export a PDF trail in seconds for legal audits,
                                partner agreements, or quarterly reports—proof of process without
                                the paperwork.
                            </p>
                        </OptimizedMotion>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Approval;
